import React from 'react';
import { Badge, Paper, Tab, Tabs } from '@mui/material';
import { ISimulationActions, SimulationTabCode } from './simulation.models';

type Props = {
  value: SimulationTabCode;
  onChange: (value: SimulationTabCode) => void;
  actions: ISimulationActions;
  blockingcount?: number;
};

class SimulationTabs extends React.PureComponent<Props> {
  render() {
    const reviewLabel = this.props.blockingcount ? (
      <Badge color="error" badgeContent={this.props.blockingcount}>Submission & Executive Review</Badge>
    ) : 'Submission & Executive Review';

    return (
      <Paper elevation={1}>
        <Tabs
          value={this.props.value}
          onChange={(_, value) => this.props.onChange(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value="executive" label="Executive Overview" />
          <Tab value="assumptions" label="Assumptions" />
          <Tab value="mixer" label="Interactive Simulation" />
          <Tab value="financials" label="Financial Analysis" />
          <Tab value="objectives" label="Objective Impact" />
          <Tab value="objectivegap" label="Objective Gap" />
          <Tab value="sensitivity" label="Sensitivity Analysis" />
          <Tab value="review" label={reviewLabel} />
        </Tabs>
      </Paper>
    );
  }
}
export default SimulationTabs;
